import { GAME_ORIGIN } from '../../../config';

type CheckIfHandleMessageParams = {
  gameName: string;
  messageOrigin: string;
  openedGameName: string;
};

export const checkIsValidMessage = ({
  gameName,
  messageOrigin,
  openedGameName
}: CheckIfHandleMessageParams) => {
  const isTrustedOrigin = messageOrigin === GAME_ORIGIN;
  const isRightGame = gameName === openedGameName;

  return isTrustedOrigin && isRightGame;
};
